import { GET_HOMEPAGE_DATA , RESET_HOMEPAGE_DATA, SET_HOMEPAGE_DATA, UPDATE_SELECTED_LANGUAGE, SET_DONATION_TYPEID, SET_CHARITY_ID, RESET_RATE_SETTING } from '../constants';
// Storing the user selected language in local storage to maintain selected language when redux-persist is purged after a transaction
// Remove language from local storage on logout
const lang = localStorage.getItem('language')

const homepage = {
    lang: lang ? lang : "en",
    isRateChanged: false,
    charityId: null, // Initialize charityId to null or any default value
    donationTypeId: null,
}

export default function homepageReducer(state = homepage , action) {

    switch(action.type) {
        case SET_HOMEPAGE_DATA:
            const homepageData = action.homepage;
            // const goldRate = (homepageData?.muisZakatHarta?.nisab?.value ?? 0) / 86;

            // homepageData.muisZakatHarta.gold.rate = goldRate.toFixed(2);
            if (homepageData?.muisZakatHarta) {
                const goldRate = (homepageData.muisZakatHarta.nisab?.value ?? 0) / 86;
                homepageData.muisZakatHarta.gold = {
                  ...(homepageData.muisZakatHarta.gold || {}),
                  rate: goldRate.toFixed(2)
                };
            }

            return { ...state, ...homepageData };
        case GET_HOMEPAGE_DATA:
            return state;
        case UPDATE_SELECTED_LANGUAGE:
            localStorage.setItem('language', action.lang)
            return { ...state, ...{ lang: action.lang } }
        case SET_CHARITY_ID:
            return { ...state, ...{ charityId: action.payload } }
        case SET_DONATION_TYPEID:
            return { ...state, ...{ donationTypeId: action.payload } }
        case RESET_RATE_SETTING:
            return { ...state, ...{ isRateChanged: false }};
        case RESET_HOMEPAGE_DATA:
            return null;
        default:
            return state;
    }

}